import React, { useState } from "react";
import { Link } from "react-router-dom";
import momoImage from "../assets/momomazza-offer.png";

export default function Home() {
  return (
    <div className="offer">
      <Link to="/spin">
        <img src={momoImage} alt="Spin offer" />
      </Link>
    </div>
  );
}
